

window.onload=function(){  
    
    window.setInterval(refreshTime,1000);

    document.getElementById('single').onclick = function(){
       popup();
    }

    document.getElementById('music').onclick = function(){
        const audio = document.getElementById('bgmusic');        
        if(audio!==null){                
          if(audio.paused){                 
            audio.play(); 
          }else{
           audio.pause();
          }
        } 
     }
};


/**
 * 弹出info
 */

function popup(){

    const info = document.getElementById('info');
    
    if( info.classList.contains('hidden') ){                
        window.setInterval(function(){
            info.innerHTML =  getSingleTime();
        },1000);      
          info.classList.remove("hidden");  
    }else{           
          info.classList.add('hidden'); 
    }    

}

/**
 * ....
 */
function getSingleTime(){
 
    const begin = new Date();
    const year = begin.getFullYear();
    const end  = new Date(year+1,10,11,0,0,0);

    return getDiff(begin,end);
}

/**
 * 更新底部时间差
 */
function refreshTime(){

    const begin = new Date(2017,11,6,0,0,0); 
    const time = getDiff (begin ,  new Date() );    
    document.getElementById('mainTime').innerHTML =  time ;

}


/**
 * 获取某一个时间到现在的时间差
 * @param {*} begin 
 * @param {*} end 
 */
function getDiff(begin , end ) {  
  
    const total_seconds = end  - begin;    

    const days = Math.floor(total_seconds / (24 * 3600 * 1000));    

    const dayLeave = total_seconds % (24 * 3600 * 1000);   
    const hours = Math.floor(dayLeave / (3600 * 1000));      

  
    const hourLeave = dayLeave % (3600 * 1000);        
    const minutes = Math.floor( hourLeave / (60 * 1000));  

    const minLeave = hourLeave % (60 * 1000);    
    const seconds = Math.round(minLeave / 1000);  

    return days  + " 天 " + hours + " 小时 " + minutes +" 分 " + seconds +" 秒 ";  
    
}  


// WEBPACK FOOTER //
// ./js/index.js